export default "__VITE_ASSET__CfT9tYXj__"